import { UserService } from 'app/shared/services/User/user.service';
import { Component, OnInit } from '@angular/core';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';
import { VendorsService } from 'shared/services/SS-vendors/vendors.service';


@Component({
  selector: 'app-md-tab-navigation',
  templateUrl: './md-tab-navigation.component.html',
  styleUrls: ['./md-tab-navigation.component.scss']
})
export class MdTabNavigationComponent implements OnInit {

  pageName: string;
  userAuth: any;

  BADGE_LOGO_URL = environment.BADGE_LOGO_URL;
  constructor(
    private userService: UserService,
    private data: DataSharingService,
    private router: Router,
    private tm: VendorsService
  ) {
    this.userAuth = JSON.parse(localStorage.getItem('SSUserCookie'));
  }

  ngOnInit() {
    this.data.currentTitle.subscribe(message => this.pageName = message);
    this.userService.authStateChange.subscribe(res => {
      this.updateState();
    });
  }

  handleUploadSeason(){
    if(environment.IS_WHITE_LABEL){
      this.router.navigate(['/new-group'], {
        queryParams: {action: "UPLOAD"} 
      });
    } else {
      // not a white label, choose team selection 
      this.router.navigate(['/new-group/choose-team']);
    }
  }
  handleViewOpenGroups() {
    if(environment.IS_WHITE_LABEL==true){
      let ID = environment.WHITE_LABEL_TEAM_ID; 
      this.router.navigate(['/new-group/public-groups'],{queryParams: {team_id: ID}})

    } else {
      this.router.navigate(['/new-group/public-groups/choose-team']);
    }
  }

  about(){
    this.router.navigate(['/about-us']);
  }

  goToHome() {
    this.router.navigate(['/new-group']);
  }

  logout() {
    this.userService.logout();
  }

  updateState() {
    this.userAuth = JSON.parse(localStorage.getItem('SSUserCookie'));
  }


}



// WEBPACK FOOTER //
// ./src/app/modules/md-tab-navigation/md-tab-navigation.component.ts